import { render, staticRenderFns } from "./ImportFoodcard.vue?vue&type=template&id=6a6ba7ca"
import script from "./ImportFoodcard.vue?vue&type=script&lang=ts"
export * from "./ImportFoodcard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports